export default {
  marketingConsent: {
    agreeCta: 'Agree and continue',
    encryptedAndSecure: 'Encrypted and secure',
    errorHeadline: 'Something went wrong',
    fallbackCopy:
      "By tapping 'Agree and continue' you're giving Varo permission to obtain and use the information in the external financial accounts you link through Plaid as set forth in Varo's General Terms and Privacy Policy.",
    fastAndEasySetup: 'Fast and easy set up',
    generalTerms: 'General Terms',
    goBackCta: 'Go back',
    headline: 'Connect your accounts with Plaid',
    legalMiddle: ' and ',
    legalPrefix:
      "By tapping 'Agree and continue' you're giving Varo permission to obtain and use the information in the external financial accounts you link through Plaid as set forth in Varo's ",
    legalSuffix: '.',
    loadingError: 'Unable to load consent details. Please try again.',
    plaidLaunchError: 'Unable to connect to Plaid. Please try again.',
    privacyPolicy: 'Privacy Policy',
    retryCta: 'Try again',
    subhead:
      'Varo uses Plaid to make moving money easy between all your accounts.',
    submitError: 'Unable to save your consent. Please try again.',
    unknownOriginError:
      'Unable to start linking from here. Please go back and try again.',
  },
  openApp: {
    title: 'Open the Varo app ',
    body: 'Almost there! Open the Varo app to finish linking your account.',
  },
};
